import React from 'react';
import { Link } from 'react-router-dom';

const Topics = ({ topic }) => {
  
    const { id, logo, name, total } = topic;
    return (
        <div className="card  glass shadow rounded border-2 ">
            <figure><img className='h-72 w-full bg-slate-800 ' src={logo} alt="car!" /></figure>
            <div className="card-body">
                <div className='grid grid-cols-2'>
                <h2 className="card-title">{ name}</h2>
                    <p>Total Questions: { total}</p>
                </div>
                <div className="card-actions w-full">
                <Link  className='w-full' to={`/quiz/${id}`}>   <button className="btn hover:bg-blue-600 text-white rounded bg-blue-800 w-full">Start Quiz</button></Link>
                </div>
            </div>
        </div>
    );
};

export default Topics;